module.exports = __webpack_public_path__ + "static/img/prize01.c56c36ba.png";